<template>
  <div class="content-box">
    <div class="element-box" v-if="current.numero != null">
      <div class="row">
        <div class="col-12">
          <div class="st-meta float-right">
            <!--button type="button" data-toggle="modal" data-target="#modalLog" class="btn btn-info">
                  <i class="fas fa-history"></i>
                  Log transacciónes
                </button-->
            &nbsp;
            <div class="btn-group">
              <div class="dropleft">
                <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-cogs"></i> Acciones
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <button type="button" @click="abrir" class="dropdown-item">Abrir</button>
                  <button type="button" @click="cerrar" class="dropdown-item">Cerrar</button>
                  <button type="button" @click="finalizar" class="dropdown-item">Finalizar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="infos">
              <div class="info-1">
                <div class="company-name">
                  {{ current.tienda_obj.codigo }} - {{ current.tienda_obj.nombre }}
                </div>
              </div>
            </div>
            <div class="">
              <h3>
                Corte de Tienda {{ current.numero }}
              </h3>
              <div class="invoice-date">
                {{ customFormatter(current.fecha_apertura) }}
              </div>
              <br>
              <span class="badge bg-danger" v-if="current.estado == 'B'">Cerrado</span>
              <span class="badge bg-success" v-if="current.estado == 'A'">Abierto</span>
              <span class="badge bg-info" v-if="current.estado == 'C'">Finalizado</span>
            </div>
            <div class="">
              <div class="invoice-desc">
                <div class="desc-label">
                  Corte # {{ current.numero }}
                </div>
                <div class="desc-value">
                </div>
              </div>
              <div class="invoice-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th>
                        Descripción
                      </th>
                      <th class="text-right">
                        Valor
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Fecha y Hora Apertura
                      </td>
                      <td class="text-right">
                        {{ customFormatter(current.fecha_apertura) }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Fecha Corte
                      </td>
                      <td class="text-right">
                        {{ customFormatter(current.fecha_corte) }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total detalle
                      </td>
                      <td class="text-right">
                        Q {{ current.total_detalle }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Resumen cortes
                      </td>
                      <td class="text-right">
                        Q {{ current.total_resumen_cortes }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="">
              <div class="invoice-desc">
                <br>
                <h4>
                  Cortes de caja
                </h4>
                <div class="desc-value">
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="invoice-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            Descripción
                          </th>
                          <th class="text-right">
                            Total Detalle
                          </th>
                          <th class="text-right">
                            Total Corte
                          </th>
                          <th class="text-right">
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="resumen_corte in cortes_disponibles">
                          <td>
                            {{ resumen_corte.caja.caja }} - Corte # {{ resumen_corte.numero }}
                          </td>
                          <td class="text-right">
                            Q {{ resumen_corte.total_detalle }}
                          </td>
                          <td class="text-right">
                            Q {{ resumen_corte.monto_total }}
                          </td>
                          <td class="text-right">
                            <button class="btn btn-sm btn-success"
                              @click="agregarAlCorteDeTienda(resumen_corte)">Agregar</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-4">
                  <div class="invoice-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            Corte Agregado
                          </th>
                          <th class="text-right">
                            Total Detalle
                          </th>
                          <th class="text-right">
                            Total Corte
                          </th>
                          <th class="text-right">
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="resumen_corte in current.cortes_de_caja">
                          <td>
                            {{ resumen_corte.caja.caja }} - Corte # {{ resumen_corte.numero }}
                          </td>
                          <td class="text-right">
                            Q {{ resumen_corte.total_detalle }}
                          </td>
                          <td class="text-right">
                            Q {{ resumen_corte.monto_total }}
                          </td>
                          <td class="text-right">
                            <button class="btn btn-sm btn-danger" v-if="current.estado == 'A'"
                              @click="quitarDelCorteDeTienda(resumen_corte)">Remover</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-4">
                  <div class="invoice-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            Descripción
                          </th>
                          <th class="text-right">
                            Valor
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="resumen_corte in current.resumen_cortes">
                          <td>
                            {{ resumen_corte.forma_pago }}
                          </td>
                          <td class="text-right">
                            Q {{ resumen_corte.total_resumen }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="">
              <br>
              <br>
              <div class="row">
                <div class="col-3" v-if="current.estado == 'A'">
                  <div class="invoice-desc">
                    <br>
                    <h4>
                      Detalle del Corte de Tienda
                    </h4>
                    <div class="desc-value">
                    </div>
                  </div>
                  <form @submit.prevent="agregarFormaDePago">
                    <div class="form-group">
                      <label for="">Fecha Operación</label>
                      <input class="form-control" v-model="nuevo_detalle.fecha_operacion" placeholder=""
                        type="datetime-local" />
                    </div>
                    <div class="row">

                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for=""> Referencia</label>
                          <input class="form-control" v-model="nuevo_detalle.referencia" placeholder="Referencia"
                            type="text" />
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for=""> Comentario</label>
                          <textarea class="form-control" v-model="nuevo_detalle.comentario" name="comentario"
                            id="comentario" cols="30" rows="5"></textarea>
                        </div>
                      </div>

                    </div>
                    <div class="row">

                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="">Banco</label>
                          <select class="form-control" v-model="nuevo_detalle.banco" @change="refreshCuentasBancarias(nuevo_detalle.banco)">
                            <option :value="banco.id" v-for="banco in bancos" :key="banco.id">{{ banco.nombre }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="">Cuentas Bancarias</label>
                          <select class="form-control" v-model="nuevo_detalle.cuenta_bancaria">
                            <option :value="cuenta_bancaria.id" v-for="cuenta_bancaria in cuentas_bancarias"
                              :key="cuenta_bancaria.id">
                              {{cuenta_bancaria.id }} - {{ cuenta_bancaria.nombre }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="col-sm-6">

                        <div class="form-group">
                          <label for="">Forma de Pago</label>
                          <select class="form-control" v-model="nuevo_detalle.forma_pago">
                            <option value="EFECTIVO">EFECTIVO</option>
                            <option value="TARJETA_CREDITO">TARJETA DE CREDITO</option>
                            <option value="CERT">CERT</option>
                            <option value="CHEQUE">CHEQUE</option>
                            <option value="DEPOSITO">DEPOSITO BANCARIO</option>
                            <option value="DEVEFEC">DEVOLUCION DE EFECTIVO</option>
                            <option value="NC">NOTA DE CREDITO</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="">Total</label>
                          <input class="form-control" v-model="nuevo_detalle.total" placeholder="Total" type="number"
                            step="0.01" min="0">
                        </div>
                      </div>

                    </div>


                    <div class="form-buttons-w">
                      <button class="btn btn-primary" type="submit"> Submit</button>
                    </div>
                  </form>

                </div>
                <div class="col-7">
                  <h4>
                    Detalle de Formas de pago
                  </h4>

                  <div class="invoice-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            Banco
                          </th>
                          <th class="">
                            Cuenta
                          </th>
                          <th class="">
                            Refer.
                          </th>
                          <th class="">
                            Forma Pago.
                          </th>
                          <th class="text-right">
                            Total
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="current_d in current.cxccortetiendadetalle_set">
                          <td>
                            {{ current_d.banco_obj.nombre }}
                          </td>
                          <td>
                            {{ current_d.cuenta_bancaria_obj.nombre }}
                          </td>
                          <td>
                            {{ current_d.referencia }}
                          </td>
                          <td class="text-right">
                            {{ current_d.forma_pago }}
                          </td>
                          <td class="text-right">
                            Q {{ current_d.total }}
                          </td>
                          <td class="text-right">
                            <button class="btn btn-sm btn-danger" v-if="current.estado == 'A'"
                              @click="quitarDetalleCorteTienda(current_d)">Remover</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-2">

                  <h4>
                    Detalle Totalizado
                  </h4>

                  <div class="invoice-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            Descripción
                          </th>
                          <th class="text-right">
                            Valor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="resumen_corte in current.totalizados_detalle">
                          <td>
                            {{ resumen_corte.forma_pago }}
                          </td>
                          <td class="text-right">
                            Q {{ resumen_corte.total_resumen }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from "lodash";

import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
  },
  data() {
    return {
      current: {
        numero: null
      },
      nuevo_detalle: {},
      bancos: [],
      cortes_disponibles: [],
      cuentas_bancarias: []
    };
  },
  computed: {
  },
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshData();
      self.refreshBancos();
    }
  },
  methods: {
    refreshData(params) {
      let self = this;
      DynamicService.getById("cxc", "corte-caja-tienda", this.$route.params.id).then((response) => {
        self.current = response.data;
        self.refreshCortesDisponibles();
      }
      );
    },
    refreshBancos(params) {
      let self = this;
      DynamicService.fetch('cat', 'bancos', { quitar_paginacion: true }).then((response) => {
        self.bancos = response.data;
        self.refreshCuentasBancarias(self.bancos[0].id)
      }
      );
    },
    refreshCuentasBancarias(banco_id) {
      let self = this;
      DynamicService.fetch('cat', 'cuenta-bancaria', { quitar_paginacion: true, banco: banco_id }).then((response) => {
        self.cuentas_bancarias = response.data;
      }
      );
    },
    refreshCortesDisponibles() {
      let self = this;
      DynamicService.getAction(
        "cxc",
        "corte-caja-tienda",
        this.$route.params.id,
        'cortes_disponibles'
      ).then((response) => {
        self.cortes_disponibles = response.data;
      });
    },
    customFormatter(date) {
      if (date == null) {
        return 'Fecha no definida';
      }
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    agregarAlCorteDeTienda(corte) {
      let self = this;
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        this.$route.params.id,
        'agregar_corte',
        {
          id: corte.id
        }
      ).then((response) => {
        self.refreshData();
      });
    },
    quitarDelCorteDeTienda(corte){
      let self = this;
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        this.$route.params.id,
        'quitar_corte',
        {
          id: corte.id
        }
      ).then((response) => {
        self.refreshData();
      });
    },
    agregarFormaDePago() {
      let self = this;
      let currentdetalle = Object.assign({}, self.nuevo_detalle);
      currentdetalle.fecha_operacion = moment(currentdetalle.fecha_operacion).format("YYYY-MM-DD HH:mm:ss");
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        this.$route.params.id,
        'agregar_forma_pago',
        currentdetalle
      ).then((response) => {
        self.refreshData();
      });
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas cerrar el corte de la tienda?",
        "Si Cerrar",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "cerrar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Corte de Tienda",
                "Corte de Tienda cerrado"
              );
              self.refreshData();
            })
            .catch((errors) => {
              console.log(errors)
              if ('data' in errors.response) {
                Notifications.alert.error(
                  "Corte de Tienda",
                  JSON.stringify(errors.response.data)
                );
              }
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas abrir el corte de la tienda?",
        "Si abrir",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "abrir"
          )
            .then((response) => {
              Notifications.alert.success(
                "Corte de Tienda",
                "Corte de Tienda abierto"
              );
              self.refreshData();
            })
            .catch((errors) => {
              if ('data' in errors.response) {
                Notifications.alert.error(
                  "Corte de Tienda",
                  JSON.stringify(errors.response.data)
                );
              }
            });
        }
      );
    },
    finalizar() {
      let self = this;
      Notifications.alert.confirm(
        "Corte de Tienda",
        "¿Deseas finalizar el corte de la tienda?",
        "Si abrir",
        function () {
          DynamicService.postAction(
            "cxc",
            "corte-caja-tienda",
            self.current.id,
            "finalizar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Corte de Tienda",
                "Corte de Tienda Finalizado"
              );
              self.refreshData();
            })
            .catch((errors) => {
              if ('data' in errors.response) {
                Notifications.alert.error(
                  "Corte de Tienda",
                  JSON.stringify(errors.response.data)
                );
              }
            });
        }
      );
    },
    quitarDetalleCorteTienda(detalle){
      let self = this;
      DynamicService.postAction(
        "cxc",
        "corte-caja-tienda",
        this.$route.params.id,
        'quitar_detalle_corte',
        {
          id: detalle.id
        }
      ).then((response) => {
        self.refreshData();
      });
    }
    
  },
};
</script>
